import React, { useState, useEffect } from 'react';
import {OverlayWrapper} from "../../../../../OverlayWrapper.tsx";
import {useAppStore} from "../../../../../../GlobalStore/GlobalStore.ts";
import {requestProjectFiles} from "../../../../../../Utils/jsBridge/sender/ide/requestProjectFiles.ts";
import { deleteEmbeddings } from '../../../../../../Utils/db/vectorDb/deleteEmbeddings.ts';
import EmbeddingStatus from "../../../../EmbeddingStatus/EmbeddingStatus.tsx";

interface EmbeddingsProps {}

const Embeddings: React.FC<EmbeddingsProps> = () => {
    const userObj = useAppStore((state: any) => state.userObj);
    const { user } = userObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { projectEmbeddingsLastUpdated, environment, vscode, projectName } = environmentObj;
    const setEnvironmentObj = useAppStore((state: any) => state.setEnvironmentObj);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { embeddingInfo } = dynamicStateObj;
    const embeddingStatus = embeddingInfo?.status;
    const [isDeleting, setIsDeleting] = useState(false);
    const [dots, setDots] = useState('');

    useEffect(() => {
        let interval: NodeJS.Timeout;
        if (isDeleting) {
            interval = setInterval(() => {
                setDots(prev => {
                    if (prev === '') return '.';
                    if (prev === '.') return '..';
                    if (prev === '..') return '...';
                    return '';
                });
            }, 500);
        }
        return () => clearInterval(interval);
    }, [isDeleting]);

    const handleCreateEmbeddings = () => {
        requestProjectFiles(environment, vscode);
    };

    const handleUpdateEmbeddings = () => {
        requestProjectFiles(environment, vscode);
    };

    const handleDeleteEmbeddings = async () => {
        setIsDeleting(true);
        try {
            await deleteEmbeddings(user, projectName);
            setEnvironmentObj({projectEmbeddingsLastUpdated: null});
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <OverlayWrapper type="paidOnly" customTooltipContent={"Embeddings are for paid users only."}>
            <div className="space-y-4 pt-2">
                <div className="text-lg font-medium border-neutral-200 dark:border-neutral-700">Embeddings</div>
                <div className="text-sm text-neutral-500 dark:text-neutral-400">
                    {!projectEmbeddingsLastUpdated && "No embeddings found for project."}
                </div>
                {projectEmbeddingsLastUpdated && (
                    <div className="text-sm text-neutral-500 dark:text-neutral-400">
                        Last updated: {new Date(projectEmbeddingsLastUpdated).toLocaleString()}
                    </div>
                )}
                {embeddingStatus && <EmbeddingStatus />}
                <div className="flex gap-2">
                    {!projectEmbeddingsLastUpdated ? (
                        <button
                            onClick={handleCreateEmbeddings}
                            disabled={embeddingStatus === "active"}
                            className="px-3 py-1.5 bg-cyan-800 text-white rounded-md hover:bg-cyan-700 transition-colors text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Create
                        </button>
                    ) : (
                        <>
                            <button
                                onClick={handleUpdateEmbeddings}
                                disabled={isDeleting || embeddingStatus === "active"}
                                className="px-3 py-1.5 bg-cyan-800 text-white rounded-md hover:bg-cyan-700 transition-colors text-sm disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                Update
                            </button>
                            <button
                                onClick={handleDeleteEmbeddings}
                                disabled={isDeleting || embeddingStatus === "active"}
                                className="px-3 py-1.5 bg-red-800 text-white rounded-md hover:bg-red-700 transition-colors text-sm disabled:opacity-50 disabled:cursor-not-allowed min-w-[70px]"
                            >
                                {isDeleting ? `Deleting${dots}` : 'Delete'}
                            </button>
                        </>
                    )}
                </div>
            </div>
        </OverlayWrapper>
    );
};

export default Embeddings;